import 'debug';
import { e as entryMixin, t as throttle } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';
import Panorama from './Panorama.js';
import './hotspots.js';

//
var script = {
  mixins: [entryMixin],
  components: {
    Panorama: Panorama
  },
  created: function created() {
    this.onHotspotClicked = throttle(this.onHotspotClicked);
  },
  methods: {
    onHotspotClicked: function onHotspotClicked(hotspot) {
      if (hotspot.href.length > 0 && hotspot.href.startsWith('/page/')) {
        this.$router.push(hotspot.href);
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "js-entry o-entry c-panorama-entry" },
    [
      _c("panorama", {
        attrs: {
          type: _vm.entryData.Json.PanoramaType,
          src: _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Image.Url,
          thumb: _vm.entryData.Image.Thumb,
          hotspots: _vm.entryData.Json.ImageMap,
          startLookAtX: _vm.entryData.Json.StartLookAtX,
          width: _vm.entryData.Width,
          height: _vm.entryData.Height
        },
        on: { "hotspot-click": _vm.onHotspotClicked }
      })
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
